import { Component } from '@angular/core';
import { NavController, NavParams, AlertController } from 'ionic-angular';
import { RequestsPage } from "../Requests/Requests";
import { AngularFireDatabase } from 'angularfire2/database';
//import { WaiterOrdersPage } from "../waiter-orders/waiter-orders";
import { PushOptions, PushObject, Push } from '@ionic-native/push';
import { AuthProvider } from "../../providers/authservice/auth";
import { Device } from '@ionic-native/device';


@Component({
  selector: 'page-waiter-dashboard',
  templateUrl: 'waiter-dashboard.html',
})
export class WaiterDashboardPage {
  ordersCount: any = [];
  loading: boolean = true;
  constructor(public navCtrl: NavController, public navParams: NavParams,
    public alertCtrl: AlertController,
    public authProvider: AuthProvider,
    private af: AngularFireDatabase,
    private push: Push,
    private device: Device, ) {
    let user = JSON.parse(localStorage.getItem('UserId'));
    this.af.object('waiterordercount/' + user.uid).valueChanges().subscribe(res => {
      this.ordersCount = res;
      this.loading = false;
    });
     console.log('Waiter Dashboard');
    if (!localStorage.getItem('chktok')){
      this.pushnotification();
      console.log('Entered inside push block')
    }
  }

  loadOrders(type) {
    //  this.navCtrl.push(WaiterOrdersPage, { type: type });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad WaiterDashboardPage');
  }
  details(type) {
    console.log('Message');
    this.navCtrl.push(RequestsPage, { type: type });
  }
  // Push Notification
  pushnotification() {
    console.log('pushnotification');
    const options: PushOptions = {
      android: {
         senderID:'976547392808'  
      },
      ios: {
        alert: 'true',
        badge: false,
        sound: 'true'
      },
    };

    const pushObject: PushObject = this.push.init(options);

    pushObject.on('notification').subscribe((notification: any) => {
      this.alert(notification.message)
    });

    pushObject.on('registration').subscribe((registration: any) => {
      console.log(registration.registrationId);
      let senderid = registration.registrationId;
      localStorage.setItem('chktok', senderid);
      let uid = this.authProvider.currentUser ? this.authProvider.currentUser.uid : this.device.uuid;
      this.af.database.ref('tokens/' + uid).set(senderid);
    });
  }

  alert(message: string) {
    this.alertCtrl.create({
      title: 'Notification!',
      subTitle: message,
      buttons: ['OK']
    }).present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/waiter-dashboard/waiter-dashboard.ts